import React, {Component, Fragment} from "react";
import canvasDown from "../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../assets/img/canvasup.png";
import {FormattedMessage} from "react-intl";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import {Link} from "react-router-dom";
import CartChangeQty from "../CartChangeQty/CartChangeQty";
import CartItemDelete from "../CartItemDelete/CartItemDelete";
import CartPrint from "../CartPrint/CartPrint";
import OrderType1ExpandedView from "../CartItem/CartItemDetails/OrderType1ExpandedView/OrderType1ExpandedView";
import OrderType3ExpandedView from "../CartItem/CartItemDetails/OrderType3ExpandedView/OrderType3ExpandedView";
import {PAGE_OPEN_TYPE, RESOURCE_BASE_URL} from "../../../../configuration";
import axios from "axios";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import No_Image from '../../../../assets/img/NO_IMAGE.png';

const ItemDetailsExpandView = (props) => {
    if (props.showMore) {
        let pcbParams = props.itemDetails.quotation.pcbParam;
        if (props.itemDetails.quotation.orderType === 1) {
            return (
                <OrderType1ExpandedView
                    pcbParams={pcbParams}
                    itemDetails={props.itemDetails}/>
            )
        } else if (props.itemDetails.quotation.orderType === 2) {
            return (
                <div>
                    <OrderType1ExpandedView
                        pcbParams={pcbParams}
                        itemDetails={props.itemDetails}/>
                    <OrderType3ExpandedView
                        smtStencilParams={props.itemDetails.quotation.stencilParam}
                        itemDetails={props.itemDetails}/>
                </div>
            )
        } else if (props.itemDetails.quotation.orderType === 3) {
            return (
                <OrderType3ExpandedView
                    smtStencilParams={props.itemDetails.quotation.stencilParam}
                    itemDetails={props.itemDetails}/>
            )
        }


    }
    return null;
};


class CartItemMobileView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            calculatedBuildTime: ''
        };

        this.changeArrow = this.changeArrow.bind(this);
        this.setEditModeMobile = this.setEditModeMobile.bind(this);
    }

    setEditModeMobile = () => {
        InitialQuotationState.cartItemEditMode = true
    };
    changeArrow = (arrowId) => {

        var acc = document.getElementsByClassName("accordion-"+arrowId);
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].classList.toggle("active");
            var panel = acc[i].nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        }

        let elm = document.getElementById("accordion-"+arrowId);
        if(elm.classList.contains("active")){

            document.getElementById("resp-down-"+arrowId).style.display = "none";
            document.getElementById("resp-up-"+arrowId).style.display = "block";
        }else {
            document.getElementById("resp-down-"+arrowId).style.display = "block";
            document.getElementById("resp-up-"+arrowId).style.display = "none";
        }

    };
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props !== prevProps){
            this.forceUpdate();
        }
    }

    componentDidMount() {



        if (this.props.item.quotation.pcbParam !== null) {
            let buildTimeJson = {
                layer: this.props.item.quotation.pcbParam.layer,
                pcbColor: this.props.item.quotation.pcbParam.pcbColor,
                qty: this.props.item.quotation.pcbParam.qty,
                thickness: this.props.item.quotation.pcbParam.thickness
            };
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            };

            let cartEditResourceUrl = RESOURCE_BASE_URL + 'api/jlcpcb/buildTime';

            axios.post(cartEditResourceUrl, buildTimeJson, axiosConfig)
                .then((res) => {
                    console.log('buildTime-aaa---------------------', res.data);
                    // alert(res.data);
                    this.setState({
                        calculatedBuildTime: res.data
                    })
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                    // alert("error");

                });
        } else {
            this.setState({
                calculatedBuildTime: "5~8日"
            })
        }
    }

    render() {
        const goTo = {
            pathname: '/gerber_viewer',
            imageUrl: this.props.item.gerberViewerUrl,
            fileUrl: this.props.item.itemName
        };
        let checked = this.props.checkedItems.includes(this.props.item.id);

        return (
            <div>
                <Fragment>
                    <div className="cart-item-mobile-resp">

                        <button className={"accordion accordion-"+this.props.i} onClick={()=>this.changeArrow(this.props.i)} id={"accordion-"+this.props.i}>
                            <input type="checkbox" onChange={() => this.props.itemData.toggleItem(this.props.item.id)}
                                   checked={checked}/>
                            &nbsp;
                            #{this.props.i} - &nbsp;
                            {this.props.item.itemName}
                            <img src={canvasDown} alt="" width='25px' className="plus" id={"resp-down-"+this.props.i}/>
                            <img src={canvasUp} alt="" width='25px' className="minus" id={"resp-up-"+this.props.i}/>
                        </button>
                        <div className="panel">
                            <div>
                                <div className="row">
                                    {this.props.item.reviewResult === true ?
                                        <div className="custom-col-3">
                                            <img alt="PCB" width={250}
                                                 src={this.props.item.gerberDto.imageUrlTopEncoded}
                                                 className="responsive-gerber-image-cart"/>
                                        </div> :
                                        <div className="custom-col-3">
                                            <img alt="PCB" width={250}
                                                 src={No_Image}
                                                 className="responsive-gerber-image-cart"/>
                                        </div>
                                    }
                                    <div className="custom-col-9 cart-item-details-responsive">
                                        <div className="row-cart-item">
                                            {this.props.item.quotation.orderType === 1 &&
                                            <b>
                                                <FormattedMessage id="app.cart.item.pcb"
                                                                  defaultMessage="PCB prototype :"
                                                                  description=""/>
                                            </b>
                                            }
                                            {this.props.item.quotation.orderType === 2 &&
                                            <b>
                                                <FormattedMessage id="app.cart.item.both"
                                                                  defaultMessage="PCB/SMT prototype :"
                                                                  description=""/>
                                            </b>
                                            }
                                            {this.props.item.quotation.orderType === 3 &&
                                            <b>
                                                SMTメタルマスク
                                            </b>
                                            }
                                            &nbsp;<b>{this.props.item.itemName}</b>
                                        </div>
                                        <div className="row-cart-item row-cart-item-left-padding font-bold-cart">
                                            <FormattedMessage id="app.cart.item.build-time"
                                                              defaultMessage="Build Time - "
                                                              description=""/>
                                            &nbsp;
                                            {this.state.calculatedBuildTime}

                                        </div>
                                        <div className="row-cart-item cart-item-total-div">
                                            <FormattedMessage id="app.cart.header.price"
                                                              defaultMessage="Price"
                                                              description=""/>
                                            &nbsp;
                                            ¥<NumberFormatter num={this.props.item.chargeDetails.totalPrice}/>
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    {/*<Link to={goTo}*/}
                                    {/*    // onClick={() => this.cartItemDto(this.props.item.gerberDto.imageUrlTop)}*/}
                                    {/*    // target=""*/}
                                    {/*      className="text-primary">*/}
                                    {/*    ガーバービューア*/}
                                    {/*</Link>*/}
                                    <ItemDetailsExpandView showMore={true}
                                                           itemDetails={this.props.item}/>
                                </div>
                                <div className="row cart-responsive-action-buttons">
                                    <div className="custom-col-4 edit-div-responsive" onClick={this.setEditModeMobile}>
                                        {/*<Link to={'pcb_quotation/' + item.id}>*/}
                                        {/*数量変更*/}
                                        {/*</Link>*/}

                                        <CartChangeQty
                                            itemId={this.props.item.id}
                                        />
                                    </div>
                                    <div className="custom-col-4 delete-div-responsive">
                                        <CartItemDelete itemDetails={this.props.item}
                                                        checkedItems={this.props.itemData.checkedItems}
                                                        userId={this.props.itemData.userId}
                                                        getCartItems={this.props.itemData.getCartItems}
                                                        onCartItemDeleted = {this.props.onCartItemDeleted}/>

                                    </div>
                                    <div className="custom-col-4 print-div-responsive">
                                        <CartPrint itemDetails={this.props.item}
                                                   userId={this.props.itemData.userId}
                                                   getCartItems={this.props.itemData.getCartItems}
                                                   checkedItems={this.props.itemData.checkedItems}/>
                                    </div>

                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </div>
        );
    }
}

export default CartItemMobileView;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartMobileView/CartItemMobileView.js